<template>
  <div class="flex act-container">
    <div>
      <act-preview navigationTitle="秒杀">
        <div class="slot">
          <div class="header-img-wrapper prev-upload">
            <div class="upload-img" @click="toggleShow">
              <span class="hmicon icon-shangchuantupian1"></span>
            </div>
            <img class="header-img" :src="listHeaderImgUrl" alt="" />
          </div>
          <div class="preview-goods-list prev-upload">
            <div
              class="upload-img"
              v-if="
                rule.seckillGoodsRuleList.length &&
                  rule.seckillGoodsRuleList[0].goodsSn
              "
              @click="batchSetting"
            >
              <span
                class="hmicon icon-shangchuantupian1 icon-hao pointer"
              ></span>
            </div>
            <div
              class="empty"
              v-if="
                rule.seckillGoodsRuleList.length &&
                  !rule.seckillGoodsRuleList[0].goodsSn
              "
            >
              还没有商品立即
              <el-button type="primary" size="mini" @click="inputChange"
                >添加商品</el-button
              >
            </div>
            <template
              v-if="
                rule.seckillGoodsRuleList.length &&
                  rule.seckillGoodsRuleList[0].goodsSn
              "
            >
              <div
                class="goods-item flex"
                v-for="(v, i) in rule.seckillGoodsRuleList"
                :key="i"
              >
                <div class="delete-item" @click="deleteChild(i)">
                  <span class="hmicon  hmicon icon-shanchu1 pointer"></span>
                </div>
                <div class="img-wrapper">
                  <img :src="v.wxshopskupic" alt="" />
                </div>
                <div class="flex-1 flex flex-column flex-between info-wrapper">
                  <div>
                    <div class="goods-name text-overflow-2">
                      {{ v.wxshopSpuName }}
                    </div>
                  </div>
                  <div
                    class="exchange-promition-wrapper"
                    v-if="v.specIdGroupName"
                  >
                    <span class="exchange-promition">
                      {{ v.specIdGroupName }}
                    </span>
                  </div>
                  <div class="flex item-center progress-wrapper">
                    <div
                      class="progress flex flex-between btn light"
                      :style="{
                        background: storeStyle.lightColor
                      }"
                    >
                      <div class="primary btn slide"></div>
                    </div>
                    <div class="primary percent">0%</div>
                  </div>
                  <div class="flex">
                    <div class="flex-1 flex item-end">
                      <div class="" v-if="v.seckillPrice">
                        <span :style="{ color: storeStyle.baseColor }"
                          >￥
                          <strong>{{ v.seckillPrice }}</strong>
                        </span>
                      </div>
                      <div v-if="v.retailPrice" class="origin-price">
                        ￥{{ v.retailPrice }}
                      </div>
                    </div>
                    <div>
                      <div
                        class="btn round"
                        :style="{ background: storeStyle.baseColor }"
                      >
                        去抢购
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-containers">
      <div class="act-step-wrapper">
        <hm-step
          :steps="steps"
          :scroll="true"
          :step="currentStep"
          @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollHeight + 'px' }">
          <div class="pvw flex flex-warp">
            <div class="flex-4">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="140px"
              >
                <div id="base">1.基本信息</div>
                <el-form-item label="活动标题" prop="gameName">
                  <el-input
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.gameName"
                    placeholder="请输入活动标题"
                  ></el-input>
                </el-form-item>
                <el-form-item label="活动时间段选择" prop="activityDate">
                  <el-date-picker
                    :default-time="['00:00:00', '23:59:59']"
                    v-model="ruleForm.activityDate"
                    :picker-options="pickerOptions0"
                    type="datetimerange"
                    align="right"
                    start-placeholder="活动开始时间"
                    end-placeholder="活动结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    class="mr10"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="活动分享文案" prop="gameShareContent">
                  <el-input
                    :maxlength="30"
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.gameShareContent"
                    placeholder="请输入活动分享文案，30字以内"
                  ></el-input>
                </el-form-item>
                <el-form-item label="背景音乐链接" prop="gameBgm">
                  <el-input
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model="ruleForm.gameBgm"
                    placeholder="请输入音乐链接/音乐网络地址"
                  ></el-input>
                </el-form-item>
                <el-form-item label="主图：" prop="mainImgUrl">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccess"
                    @crop-upload-fail="cropUploadFail"
                    v-model="show"
                    v-if="show"
                    noCircle
                    noSquare
                    :width="750"
                    :height="360"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>
                  <!-- <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                noCircle
                noSquare
                :params="{ fileDir: 'mallDecoration' }"
                :headers="{ 'X-Access-Token': $token }"
                :width="750"
                :height="1334"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload> -->
                  <el-button
                    type="primary"
                    size="small"
                    v-show="!listHeaderImgUrl"
                    @click="toggleShow"
                    >上传</el-button
                  >
                  <span class="form-tip"
                    >图片尺寸建议750x360（最多上传一张）</span
                  >
                  <div class="priview" v-if="listHeaderImgUrl">
                    <img :src="listHeaderImgUrl" alt="主图" />
                    <div class="opreat-wrapper flex item-center flex-center">
                      <el-button type="text" @click="toggleShow">更换</el-button>
                    </div>
                    <!--div class="opreat-wrapper flex item-center flex-center">
                      <el-button type="text" @click="handleRemove"
                        >删除</el-button
                      >
                    </div -->
                  </div>
                </el-form-item>

                <el-form-item label="活动规则说明" prop="gameRuleRemark">
                  <hm-rich-editor
                    v-model="ruleForm.gameRuleRemark"
                    :html="ruleForm.gameRuleRemark"
                  />
                </el-form-item>

                <el-form-item label="虚拟参与人数" prop="visualJoinNum">
                  <span>在实际参与人数基础上增加</span
                  ><el-input
                    type="number"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.visualJoinNum"
                    placeholder="请输入数字"
                  ></el-input
                  >人
                </el-form-item>
                <div id="gameRule">
                  {{ steps.length === 3 ? 2 : 2 }}活动规则
                </div>

                <el-form-item label="秒杀场次" prop="screening">
                  <div class="flex flex-wrap">
                    <el-select
                      clearable
                      class="mr10 "
                      size="small"
                      v-model="screening"
                      placeholder="请选择秒杀场次"
                    >
                      <el-option label="1" value="1"></el-option>
                      <el-option label="2" value="2"></el-option>
                      <el-option label="3" value="3"></el-option>
                      <el-option label="4" value="4"></el-option>
                      <el-option label="5" value="5"></el-option>
                      <el-option label="6" value="6"></el-option>
                      <el-option label="7" value="7"></el-option>
                      <el-option label="8" value="8"></el-option>
                      <el-option label="9" value="9"></el-option>
                      <el-option label="10" value="10"></el-option>
                    </el-select>
                    <div class="form-tip">
                      最多可以设置十个场次，每场次时间不允许出现重叠
                    </div>
                  </div>
                </el-form-item>

                <el-form-item prop="drawTypeDate">
                  <div
                    v-for="(item, index) in rule.seckillRuleList"
                    :key="index"
                  >
                    <span>场次{{ index + 1 }} </span>
                    <el-date-picker
                      @change="dateUpdate"
                      :default-time="['00:00:00', '23:59:59']"
                      v-model="item.activityDate"
                      type="datetimerange"
                      align="right"
                      start-placeholder="活动开始时间"
                      end-placeholder="活动结束时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      size="small"
                      class="mr10"
                    ></el-date-picker>
                  </div>
                </el-form-item>
                <div>
                  <el-form-item label="是否在商城显示限购数" prop="drawTypeList" label-width="200">
                    <el-switch class="reward"
                               v-model="ruleForm.restrictionsShowState"
                               active-color="#2d8"
                               inactive-color="#ff4949"
                               active-text="显示"
                               inactive-text="隐藏"
                               active-value="yes"
                               inactive-value="no"
                    ></el-switch>
                  </el-form-item>
<!--                  <el-form-item label="是否在商城显示剩余库存数" prop="drawTypeList" label-width="200">-->
<!--                  <el-switch class="reward"-->
<!--                             v-model="ruleForm.remainStockShowState"-->
<!--                             active-color="#2d8"-->
<!--                             inactive-color="#ff4949"-->
<!--                             active-text="显示"-->
<!--                             inactive-text="隐藏"-->
<!--                             active-value="yes"-->
<!--                             inactive-value="no"-->
<!--                  ></el-switch>-->
<!--                </el-form-item>-->
                </div>
                <el-form-item label="添加商品" prop="drawTypeList">
                  <div class="ml10">
                    <el-button size="small" type="text" @click="addGoods"
                      >添加商品</el-button
                    >
                  </div>
                  <div class="form-item-tip primary">
                    拖拽序号移动
                  </div>
                  <div class="flex batch flex-between">
                    <div class="form-tip">
                      <!-- 至少保留一条商品信息 -->
                    </div>
                    <div class="flex flex-center">
                      <div @click="outputExcel" class="delete mr20 pointer">
                        <span class="delete-icon hmicon icon-daochu"></span>
                        导出模板
                      </div>
                      <div class="delete mr20 pointer open-file">
                        <span class="delete-icon hmicon icon-daoru"></span>
                        导入
                        <input
                          type="file"
                          @change="importf"
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                      </div>
                      <div @click="batchSetting" class="pointer">
                        <span class="delete-icon hmicon icon-xitong"></span>
                        批量设置场次
                      </div>
                    </div>
                  </div>
                  <el-table
                    :data="rule.seckillGoodsRuleList"
                    row-key="wxshopSkuId"
                    border
                    stripe
                    max-height="400"
                    style="width: 100%"
                    :header-cell-style="{
                      background: '#f7f7f7',
                      color: '#606266'
                    }"
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="50"
                      class-name="my-handle move"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsSn"
                      label="商品货号"
                    >
                      <template slot-scope="scope">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="scope.row.goodsSn"
                          placement="top"
                          :disabled="!scope.row.goodsSn"
                        >
                          <el-input
                            clearable
                            style="width:120px"
                            @focus="inputChange"
                            v-model.trim="scope.row.goodsSn"
                            size="small"
                            placeholder="商品货号"
                          ></el-input>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="wxshopSpuName"
                      label="商品名称"
                    >
                      <template slot-scope="scope">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="scope.row.wxshopSpuName"
                          placement="top"
                          :disabled="!scope.row.wxshopSpuName"
                        >
                          <el-input
                            clearable
                            @focus="inputChange"
                            style="width:120px"
                            v-model.trim="scope.row.wxshopSpuName"
                            size="small"
                            placeholder="商品名称"
                          ></el-input>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="specIdGroupName"
                      label="商品规格"
                    >
                      <template slot-scope="scope">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="scope.row.specIdGroupName"
                          placement="top"
                          :disabled="!scope.row.specIdGroupName"
                        >
                          <div>
                            {{ scope.row.specIdGroupName }}
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="eachPurchaseLimit"
                      label="单人限购"
                    >
                      <template slot-scope="scope">
                        <el-input
                          style="width:100px"
                          v-model.trim="scope.row.eachPurchaseLimit"
                          size="small"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed('eachPurchaseLimit', scope.$index)
                          "
                          clearable
                          placeholder="限购人数"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="bargainTotalStockSum"
                      label="活动库存"
                    >
                      <template slot="header">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="活动库存与商品总库存无关"
                          placement="top"
                        >
                          <div class="text-center primary">活动库存</div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <el-input
                          style="width:100px"
                          v-model.trim="scope.row.bargainTotalStockSum"
                          size="small"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed(
                              'bargainTotalStockSum',
                              scope.$index
                            )
                          "
                          clearable
                          placeholder="活动库存"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="retailPrice"
                      label="零售价"
                    >
                      <template slot-scope="scope">
                        <el-input
                          clearable
                          style="width:100px"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2('retailPrice', scope.$index)
                          "
                          v-model.trim="scope.row.retailPrice"
                          size="small"
                          placeholder="零售价"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="seckillPrice"
                      label="秒杀价"
                    >
                      <template slot-scope="scope">
                        <el-input
                          clearable
                          style="width:100px"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2('seckillPrice', scope.$index)
                          "
                          v-model.trim="scope.row.seckillPrice"
                          size="small"
                          placeholder="秒杀价"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="seckillPrice"
                      label="参与场次"
                    >
                      <template slot="header">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="一个商品可以参加多个场次活动，上一场次活动未销售完可以进入下一场次"
                          placement="top"
                        >
                          <div class="text-center primary">参与场次</div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <el-select
                          style="width:100px"
                          multiple
                          clearable
                          size="small"
                          v-model="scope.row.roundSeqNumGroupArray"
                          placeholder="请选择场次"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="takeOrderDate"
                        label="提货时间"
                    >
                    <template slot-scope="scope">
                      <el-date-picker
                          class="mr10"
                          size="small"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions0"
                          v-model="scope.row.takeOrderDate"
                          type="date"
                          placeholder="选择日期"
                      ></el-date-picker>
                    </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                      width="200"
                    >
                      <template slot-scope="scope">
                        <!-- <div class="flex flex-center">
                          <div
                            v-if="scope.$index === 0"
                            class="add-wrapper flex flex-center"
                            style="marginLeft:0"
                          >
                            <span
                              class="hmicon icon-hao pointer"
                              @click="addChild(scope.$index)"
                            ></span>
                          </div>
                          <div
                            class="minus-wrapper flex flex-center"
                            style="marginLeft:0"
                            v-else
                          >
                            <span
                              class="hmicon icon-jianhao pointer"
                              @click="deleteChild(scope.$index)"
                            ></span>
                          </div>
                        </div> -->
                        <div>
                          <el-button
                            size="small"
                            type="text"
                            @click="toFirst(scope.$index)"
                            v-if="scope.$index !== 0"
                            >置顶</el-button
                          >
                          <el-button
                            size="small"
                            type="text"
                            @click="upGo(scope.$index)"
                            v-if="scope.$index !== 0"
                            >上移</el-button
                          >
                          <el-button
                            size="small"
                            type="text"
                            @click="downGo(scope.$index)"
                            v-if="
                              scope.$index !== rule.seckillGoodsRuleList.length - 1 ||
                                scope.$index === 0
                            "
                            >下移</el-button
                          >

                          <el-button
                            size="small"
                            type="text"
                            v-if="
                              scope.$index !== rule.seckillGoodsRuleList.length - 1 ||
                                scope.$index === 0
                            "
                            @click="toBottom(scope.$index)"
                            >置底</el-button
                          >
                          <el-button
                            size="small"
                            type="text"
                            @click="deleteChild(scope.$index)"
                            >删除</el-button
                          >
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- <div class="table game-select">
                  <div class="table-header flex">
                    <div class="flex-1 text-center">商品货号</div>
                    <div class="flex-1 text-center">商品名称</div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="单人限购数量"
                      placement="top"
                    >
                      <div class="flex-1 text-center primary">单人限购</div>
                    </el-tooltip>
                    <div class="flex-1 text-center">活动库存</div>
                    <div class="flex-1 text-center">零售价</div>
                    <div class="flex-1 text-center">秒杀价</div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="一个商品可以参加多个场次活动，上一场次活动未销售完可以进入下一场次"
                      placement="top"
                    >
                      <div class="flex-1 text-center primary">参与场次</div>
                    </el-tooltip>
                    <div class="flex-1 text-center">操作</div>
                  </div>
                  <div class="table-body">
                    <div
                      class="flex table-row item-center"
                      v-for="(item, index) in rule.seckillGoodsRuleList"
                      :key="index"
                    >
                      <div class="flex-1 text-center">
                        <el-input
                          @focus="inputChange"
                          style="width:120px"
                          v-model.trim="item.goodsSn"
                          size="small"
                          placeholder="请选择商品货号"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          @focus="inputChange"
                          style="width:100px"
                          v-model.trim="item.wxshopSpuName"
                          size="small"
                          placeholder="请选择商品名称"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          type="number"
                          maxlength="30"
                          @mousewheel.prevent.native
                          style="width:120px"
                          v-model.trim="item.eachPurchaseLimit"
                          @input="filterGt0OrFixed('eachPurchaseLimit', index)"
                          size="small"
                          clearable
                          placeholder="请输入数字"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          type="number"
                          maxlength="30"
                          @mousewheel.prevent.native
                          style="width:100px"
                          v-model.trim="item.bargainTotalStockSum"
                          size="small"
                          @input="
                            filterGt0OrFixed('bargainTotalStockSum', index)
                          "
                          clearable
                          placeholder="请输入库存"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          type="number"
                          maxlength="30"
                          clearable
                          @mousewheel.prevent.native
                          style="width:120px"
                          v-model.trim="item.retailPrice"
                          @input="filterGt0OrFixed2('retailPrice', index)"
                          size="small"
                          placeholder="零售价"
                        ></el-input>
                      </div>

                      <div class="flex-1 text-center">
                        <el-input
                          type="number"
                          maxlength="30"
                          clearable
                          @mousewheel.prevent.native
                          style="width:120px"
                          v-model.trim="item.seckillPrice"
                          @input="filterGt0OrFixed2('seckillPrice', index)"
                          size="small"
                          placeholder="秒杀价"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-select
                          multiple
                          clearable
                          size="small"
                          v-model="item.roundSeqNumGroupArray"
                          placeholder="请选择场次"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="flex-1">
                        <div
                          class="add-wrapper flex flex-center"
                          v-if="index === 0"
                        >
                          <span
                            class="hmicon icon-hao pointer"
                            @click="addChild(index)"
                          ></span>
                        </div>
                        <div class="minus-wrapper flex flex-center" v-else>
                          <span
                            class="hmicon icon-jianhao pointer"
                            @click="deleteChild(index)"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
                </el-form-item>
                <!-- <el-form-item label="预计参与次数" prop="estimatedNum"
                ><el-input
                  type="number"
                  maxlength="30"
                  @mousewheel.prevent.native
                  style="width: 100px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.estimatedNum"
                  placeholder="请输入次数"
                ></el-input
                >次
              </el-form-item> -->
                <!-- <div id="gameAstrict">
                {{ steps.length === 3 ? 3 : 3 }}活动限制
              </div>
              <el-form-item label="配送方式限制" prop="expressModeGroup">
                <el-checkbox-group v-model="threshold.expressModeGroup">
                  <el-checkbox label="shop_extract">门店自提</el-checkbox>
                  <el-checkbox label="express_delivery">快递物流</el-checkbox>
                </el-checkbox-group>
              </el-form-item> -->
                <el-form-item label="配送方式限制" prop="expressModeGroups">
                  <el-checkbox-group v-model="ruleForm.expressModeGroups">

                    <span class="title" style="display:flex;aligin-items:center; color:#666; font-size:14px; margin-right:16px;">
                      选择门店：
                      <div @click="outputExcelStores" class="delete pointer">
                        <span class="delete-icon hmicon icon-daochu"></span>
                        下载模板
                      </div>
                      <div class="delete mr20 pointer open-file" style="margin-left:20px;">
                        <span class="delete-icon hmicon icon-daoru"></span>
                        导入
                        <input
                            type="file"
                            @change="importfStore"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                      </div>
                    </span>

                    <div>
                      <el-checkbox label="shop_extract">门店自提</el-checkbox>
                      <el-select
                        class="ml10"
                        clearable
                        multiple
                        v-model="ruleForm.shopIds"
                        placeholder="请选择可销售门店"
                        size="small"
                        filterable
                        @change="getCheckedStore"
                        v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
                      >
                        <el-option
                          label="全部门店"
                          value="all"
                          :disabled="selectOther"
                        ></el-option>
                        <el-option
                          :disabled="selectAll"
                          :label="v.shopName"
                          :value="v.shopId"
                          v-for="(v, i) in microShopStoreList"
                          :key="i"
                        ></el-option>
                      </el-select>

                      <el-select
                          class="ml10"
                          clearable
                          multiple
                          v-model="ruleForm.shopIds"
                          placeholder="请选择可销售门店"
                          size="small"
                          filterable
                          @change="getCheckedStore"
                          v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
                      >
                        <el-option
                            label="全部门店"
                            value="all"
                            :disabled="selectOther"
                        ></el-option>
                        <el-option
                            :disabled="selectAll"
                            :label="v.shopName"
                            :value="v.shopId"
                            v-for="(v, i) in dkMicroShopStoreList"
                            :key="i"
                        ></el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-checkbox label="express_delivery"
                        >快递物流</el-checkbox
                      >
                      <el-select
                        size="small"
                        v-model="ruleForm.expressId"
                        filterable
                        class="ml10"
                        clearable
                        placeholder="请选择运费模板"
                      >
                        <el-option
                          :label="v.expressName"
                          :value="v.expressId"
                          v-for="(v, i) in expressList"
                          :key="i"
                        ></el-option>
                      </el-select>
                    </div>
                  </el-checkbox-group>
                </el-form-item>







                <div class="flex flex-center">
                  <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('ruleForm')"
                    >发布</el-button
                  >
                  <el-button size="small" @click="$router.back(-1)"
                    >返回</el-button
                  >
                </div>
              </el-form>
            </div>
            <!-- <div class="text-center " style="width:120px">
              <el-button
                class="fixed-but"
                size="small"
                type="danger"
                round
                @click="minimum"
                v-if="isCollapse"
              >
                <span class="hmicon icon-shouji"></span>
                <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
                <span class="hmicon icon-youshuangjiantou arrow"></span>
              </el-button>
              <el-button
                v-else
                class="fixed-but"
                size="small"
                type="primary"
                round
                @click="minimum"
              >
                <span class="hmicon icon-shouji"></span>
                <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
                <span class="hmicon icon-youshuangjiantou arrow"></span>
              </el-button>
            </div>
            <div class="pvws flex:1" v-show="!isCollapse">
              <img
                style="width:100%"
                src="https://imgcdn.hemiao100.com/ThemePictures/miaosha1.png"
                alt=""
              />
            </div> -->
          </div>
        </el-scrollbar>
      </div>
      <!-- <hm-filter-micro-shop-goods
        type="microShop"
        :visible="dialogVisible"
        :radio="isRadio"
        @saveGoods="saveGoods"
        @setLink="setLink"
        @close="dialogVisible = false"
      ></hm-filter-micro-shop-goods> -->
    </div>
    <el-dialog
      title="批量设置"
      width="500px"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleBatch"
      :before-close="handleClose"
    >
      <div class="flex tabs">
        <el-tabs tab-position="left" v-model="tabType">
          <el-tab-pane label="批量设置场次">
            <el-select
              clearable
              multiple
              v-model="batchRoundSeqNumGroupArray"
              @change="batchNumGroup"
              placeholder="请选择场次"
              size="small"
              filterable
              class="mr10"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
            prop="goodsSn"
            header-align="center"
            align="center"
            label="无效货号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="specBarcode"
            label="无效条码"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <hm-filter-m-s-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-m-s-goods>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
// import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmCountdown from "@/components/HmCountdown";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";
import Sortable from "sortablejs";
import { arrayUnique2 } from "@/utils/utils";
import XLSX from "xlsx";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
import {getLoginUser} from "@/utils/auth";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    HmFilterMSGoods,
    HmCountdown,
    actPreview
  },
  data() {
    const expressModeGroupsStatus = (rule, val, callback) => {
      if (val.findIndex(v => v === "shop_extract") > -1) {
        if (!this.ruleForm.shopIds.length) {
          return callback(new Error("请选择可销售门店"));
        }
      }
      if (val.findIndex(v => v === "express_delivery") > -1) {
        if (!this.ruleForm.expressId) {
          return callback(new Error("请选择运费模板"));
        }
      }

      callback();
    };
    const actDate = function(rule, val, callback) {
      // if (val > +this.ruleForm.actMemberUpperLimit) {
      //   return callback(new Error("已报名人数不能大于活动人数上限"));
      // }

      if (
        this.ruleForm.activityDate &&
        !this.ruleForm.activityDate.length > 0
      ) {
        return callback(new Error("请选择活动时间段"));
      }
      const endTime = new Date(val[0]);
      const nowTime = new Date();
      let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
      if (leftTime < 0) {
        this.start = false;
      } else {
        this.start = true;
      }

      callback();
    }.bind(this);
    const patterndRemarkFunc = function(rule, val, callback) {
      if (!this.ruleForm.gameRuleRemark) {
        return callback(new Error("请输入活动规则说明"));
      }
      callback();
    }.bind(this);
    const patterndDrawTypeDateFunc = function(rule, val, callback) {
      this.rule.seckillRuleList.map(v => {
        if (v.activityDate && !v.activityDate.length > 0) {
          return callback(new Error("请选择秒杀场次时间段"));
        }
      });
      callback();
    }.bind(this);
    const patterndMainImgUrlFunc = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请选择主图"));
      }
      callback();
    }.bind(this);
    const patterndDrawTypeFunc = function(rule, val, callback) {
      if (this.screening) {
        callback();
      } else {
        return callback(new Error("请选择秒杀场次"));
      }
    }.bind(this);
    const patterndDrawTypeListFunc = function(rule, val, callback) {
      let flag = true;
      this.rule.seckillGoodsRuleList.map(v => {
        if (
          !v.goodsSn ||
          !v.eachPurchaseLimit ||
          !v.bargainTotalStockSum ||
          !v.retailPrice ||
          !v.seckillPrice ||
          !v.roundSeqNumGroupArray.length > 0
        ) {
          flag = false;
        }
      });
      if (flag) {
        callback();
      } else {
        console.log("this.rule.seckillGoodsRuleList:",this.rule.seckillGoodsRuleList);
        return callback(new Error("请填写所有项"));
      }
    }.bind(this);
    return {
      storeCode: "",
      selectOther: false,
      selectAll: false,
      expressList: [],
      errValidGoods: false,
      errInputResult: [],
      pickerOptions0: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      endTime: "2019-11-11 18:12:00",
      isRadio: false,
      listHeaderImgUrl:
        "https://imgcdn.hemiao100.com/ThemePictures/miaosha.png",
      storeId: "",
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      dialogVisible: false,
      batchRoundSeqNumGroupArray: [],
      tabType: "",
      dialogVisibleBatch: false,
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        },
        {
          id: "gameAstrict",
          name: "活动限制"
        }
      ],
      ruleForm: {
        activityDate: "",
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgm: "",
        visualJoinNum: "0",
        expressModeGroups: [],
        shopIds: [],
        expressId: "",
        remainStockShowState: "no",
        restrictionsShowState: "no"
      },
      screening: "1",
      rule: {
        // activityDate: "",
        seckillRuleList: [
          {
            activityDate: [],
            roundSeqNum: "",
            roundStartTime: "",
            roundEndTime: ""
          }
        ],
        seckillGoodsRuleList:[],
        // seckillGoodsRuleList: [
        //   {
        //     goodsSn: "",
        //     wxshopSpuName: "",
        //     eachPurchaseLimit: "",
        //     bargainTotalStockSum: "",
        //     retailPrice: "",
        //     seckillPrice: "",
        //     takeOrderDate: "",
        //     roundSeqNumGroupArray: []
        //   }
        // ]

      },
      threshold: {
        expressModeGroup: []
      },
      rules: {
        visualJoinNum: [
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            message: "请输入虚拟参与人数",
            trigger: "blur"
          }
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patterndMainImgUrlFunc,
            trigger: "blur"
          }
        ],
        gameRuleRemark: [
          {
            required: true,
            validator: patterndRemarkFunc,
            trigger: "blur"
          }
        ],
        activityDate: [
          {
            required: true,
            message: "请选择活动时间",
            trigger: "blur"
          },
          {
            validator: actDate,
            trigger: "blur",
            required: true
          }
        ],
        drawTypeDate: {
          trigger: "blur",
          validator: patterndDrawTypeDateFunc,
          required: true
        },
        screening: [
          {
            required: true,
            validator: patterndDrawTypeFunc,
            trigger: "blur"
          }
        ],
        drawTypeList: [
          {
            required: true,
            validator: patterndDrawTypeListFunc,
            trigger: "blur"
          }
        ],
        // estimatedNum: [
        //   {
        //     required: true,
        //     message: "请填写预计参与次数",
        //     trigger: "blur"
        //   }
        // ],
        expressModeGroups: [
          {
            required: true,
            message: "请选择配送方式限制"
          },
          {
            required: true,
            validator: expressModeGroupsStatus
          }
        ]
      },

      options: [
        {
          value: "1",
          label: "1"
        }
      ],
      start: true,
      sole: Boolean,
      isCollapse: true
    };
  },
  computed: mapGetters(["storeStyle", "microShopStoreList", "dkMicroShopStoreList"]),
  watch: {
    screening(val) {
      this.rule.seckillRuleList = [];
      this.rule.seckillGoodsRuleList = [];
      // this.rule.seckillGoodsRuleList = [
      //   {
      //     goodsSn: "",
      //     eachPurchaseLimit: "",
      //     bargainTotalStockSum: "",
      //     retailPrice: "",
      //     seckillPrice: "",
      //     roundSeqNumGroupArray: []
      //   }
      // ];
      this.options = [];
      for (let i = 1; i <= val; i++) {
        this.rule.seckillRuleList.push({
          activityDate: "",
          roundSeqNum: "",
          roundStartTime: "",
          roundEndTime: ""
        });
        this.options.push({
          value: i,
          label: i
        });
      }
    }
  },
  created() {
    this.queryExpressList();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcHeight();
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:",this.storeCode);
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
    this.$store.dispatch("findCouponSendByEvent");
    if (this.$route.query.gameId) {
      this.activityDetail();
    }
    this.$store.dispatch("queryStoreStyle");
    this.rowDrop();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 导出excel
    outputExcelStores() {
      console.log('导出excel')
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商店名称",
          "商店编码"
        ];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "门店模板");
      });
    },
    // 导入excel
    importfStore(e) {
      console.log('导入excel')
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = async function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        let isRequired = true;
        result.forEach(v => {
          if (!v[0] || !v[1] ) {
            isRequired = false;
          } else {
            isRequired = true
          }
          formatResult.push({
            shopName:v[0],
            shopId:v[1]
          });
        });
        if (isRequired) {

          let arrs = []
          formatResult.forEach(v => {
            arrs.push({shopCode:v.shopId})
          });;
          const { result } = await that.$store.dispatch("importFilterShopCodeList", arrs);
          if(result && result.successShopInfoModelList){
            that.ruleForm.shopIds = result.successShopInfoModelList.map(e=>e.shopId);
          }

        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整商店信息！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },

    // 运费模板
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "all") > -1;
      this.selectAll = storeList.findIndex(o => o === "all") > -1;
      if (this.selectAll) {
        this.ruleForm.shopIds = ["all"];
      }
    },
    dateUpdate() {
      this.$forceUpdate();
    },
    async activityDetail() {
      const { gameId } = this.$route.query;
      const params = {
        gameId
      };
      const { result } = await this.$store.dispatch(
        "queryActivitDetail",
        params
      );
      result.expressModeGroups = result.expressModeGroups || [];
      result.shopIds = result.shopIds || [];
      this.screening = result.rule.seckillRuleList.length;
      setTimeout(() => {
        this.rule.seckillRuleList.forEach((v, i) => {
          result.rule.seckillRuleList.forEach(() => {
            this.rule.seckillRuleList[i].activityDate = [
              result.rule.seckillRuleList[i].roundStartTime,
              result.rule.seckillRuleList[i].roundEndTime
            ];
          });
        });
      }, 0);
      setTimeout(() => {
        for (let key in result) {
          this.ruleForm[key] = result[key];
        }
        this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];
        this.listHeaderImgUrl = result.gameBgp;
        this.rule.seckillGoodsRuleList = result.rule.seckillGoodsRuleList;
        this.threshold = result.threshold;
      }, 0);
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    addChild() {
      this.rule.seckillGoodsRuleList.push({
        goodsSn: "",
        eachPurchaseLimit: "",
        bargainTotalStockSum: "",
        retailPrice: "",
        seckillPrice: "",
        roundSeqNumGroupArray: []
      });
    },
    deleteChild(index) {
      // if (this.rule.seckillGoodsRuleList.length <= 1) {
      //   this.rule.seckillGoodsRuleList = [];
      //   this.addChild();
      //   return;
      // }
      this.rule.seckillGoodsRuleList.splice(index, 1);
    },
    filterGt0OrFixed(prop, i) {
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop]
        .replace(".", "")
        .replace("-", "");
      // this.rule.seckillGoodsRuleList[i].prop = this.rule.seckillGoodsRuleList[
      //   i
      // ][prop].replace(/[^\d]/g, ""); //仅保留数字
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."

      // //去除其他"."
      // this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
      //   i
      // ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      // if (
      //   this.rule.seckillGoodsRuleList[i][prop].indexOf(".") < 0 &&
      //   this.rule.seckillGoodsRuleList[i][prop] != ""
      // ) {
      //   //首位是0的话去掉
      //   this.rule.seckillGoodsRuleList[i][prop] = parseFloat(
      //     this.rule.seckillGoodsRuleList[i][prop]
      //   );
      // }
    },
    filterGt0OrFixed2(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.rule.seckillGoodsRuleList[i][prop] = this.rule.seckillGoodsRuleList[
        i
      ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.rule.seckillGoodsRuleList[i][prop].indexOf(".") < 0 &&
        this.rule.seckillGoodsRuleList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.rule.seckillGoodsRuleList[i][prop] = parseFloat(
          this.rule.seckillGoodsRuleList[i][prop]
        );
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          this.ruleForm.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";

          if (this.ruleForm.enabledState && this.ruleForm.updateMode) {
            this.ruleForm.enabledState = "";
            this.ruleForm.updateMode = "";
          }

          this.rule.seckillRuleList.forEach((v, i) => {
            v.roundSeqNum = i + 1;
            v.roundStartTime =
              v.activityDate && v.activityDate.length > 0
                ? v.activityDate[0]
                : "";
            v.roundEndTime =
              v.activityDate && v.activityDate.length > 0
                ? v.activityDate[1]
                : "";
          });

          let params = this.ruleForm;
          params.gameType = "seckill";
          params.gameBgp = this.listHeaderImgUrl;
          //   if (this.rule.screening == "daily") {
          //     this.rule.drawPrizeNum = this.rule.drawPrizeNumDaily;
          //     this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitDaily;
          //   } else {
          //     this.rule.drawPrizeNum = this.rule.drawPrizeNumTotal;
          //     this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitTotal;
          //   }

          params = Object.assign(params, {
            rule: this.rule
            // threshold: this.threshold
          });
          // params.threshold.expressModeGroup = ["shop_extract"];
          this.$store.dispatch("addTurntable", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号", "商品条码"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "秒杀活动商品模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let goodsSnsAndSpecBarcode = [];
        result.forEach(v => {
          if (v[0] || v[1]) {
            goodsSnsAndSpecBarcode.push({
              goodsSn: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              specBarcode: v[1] ? (v[1] + "").replace(/\s*/g, "") : ""
            });
          }
        });

        that.$store
          .dispatch("queryWxshopSkuByGoodsSn", { goodsSnsAndSpecBarcode })
          .then(res => {
            const { code, result } = res;
            if (code === "0") {
              if (result.modelList.length > 0) {
                result.modelList.forEach(v => {
                  v.bargainTotalStockSum = "";
                  v.eachPurchaseLimit = "";
                  v.seckillPrice = "";
                  v.retailPrice = "";
                  v.roundSeqNumGroupArray = [];
                });
                that.rule.seckillGoodsRuleList.push(...result.modelList);
                that.rule.seckillGoodsRuleList = arrayUnique2(
                  that.rule.seckillGoodsRuleList,
                  "wxshopSkuId"
                );
                let list = [];
                that.rule.seckillGoodsRuleList.forEach(v => {
                  if (v.goodsSn !== "") {
                    list.push(v);
                  }
                });
                that.rule.seckillGoodsRuleList = list;
                that.$forceUpdate();
              }
              if (result.errGoodsSnsAndSpecBarcode.length > 0) {
                that.errValidGoods = true;
                that.errInputResult = result.errGoodsSnsAndSpecBarcode;
              }
            }
          });
        // const formatResult = [];
        // let isValidPhone = true;
        // if (result.length > 0) {
        //   result.forEach(v => {
        //     if (!v[0] || !v[6]) {
        //       isValidPhone = false;
        //     }
        //     formatResult.push({
        //       goodsSn: v[0],
        //       wxshopSpuName: v[1],
        //       eachPurchaseLimit: v[2],
        //       bargainTotalStockSum: v[3],
        //       retailPrice: v[4],
        //       seckillPrice: v[5],
        //       specBarcode: v[6],
        //       roundSeqNumGroupArray: []
        //     });
        //   });
        // } else {
        //   isValidPhone = false;
        // }

        // if (isValidPhone) {
        //   let errList = formatResult.filter((item, index, self) => {
        //     for (let i = index + 1; i < self.length; i++) {
        //       if (self[i].specBarcode === item.specBarcode) {
        //         return true;
        //       }
        //     }
        //     return false;
        //   });
        //   if (errList.length > 0) {
        //     that.errValidGoods = true;
        //     that.errInputResult = errList;
        //     that.$message({
        //       message: "导入失败，有重复条码！",
        //       type: "warning"
        //     });
        //   } else {
        //     that.rule.seckillGoodsRuleList = formatResult;
        //   }
        //   // that.memberCount = formatResult.length;
        // } else {
        //   that.$message({
        //     message: "货号和条码不能为空！",
        //     type: "warning"
        //   });
        // }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    saveGoods(data) {
      if (data.length > 0) {
        this.dialogVisible = false;

        // if (this.rule.seckillGoodsRuleList.length === 1) {
        //   this.rule.seckillGoodsRuleList = [];
        // }
        // if (this.sole) {
        //   this.rule.seckillGoodsRuleList.splice(
        //     this.rule.seckillGoodsRuleList.length - 1,
        //     1
        //   );
        // }
        // this.rule.seckillGoodsRuleList.push(...data);

        data.map(v => {
          this.rule.seckillGoodsRuleList.push({
            wxshopSpuName: v.wxshopSpuName,
            goodsSn: v.goodsSn,
            specIdGroupName: v.specIdGroupName,
            eachPurchaseLimit: v.eachMemberPurchaseLimit,
            bargainTotalStockSum: v.stockNum,
            retailPrice: v.showPrice || v.wxshopPrice,
            seckillPrice: "",
            wxshopSkuId: v.wxshopSkuId,
            roundSeqNumGroupArray: []
          });
        });
        this.rule.seckillGoodsRuleList = arrayUnique2(
          this.rule.seckillGoodsRuleList,
          "wxshopSkuId"
        );

        // let obj = {};

        // let peon = this.rule.seckillGoodsRuleList.reduce((cur, next) => {
        //   obj[next.goodsSn] ? "" : (obj[next.goodsSn] = true && cur.push(next));
        //   return cur;
        // }, []); //设置cur默认类型为数组，并且初始值为空的数组

        // this.rule.seckillGoodsRuleList = peon;
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning"
        });
      }
    },
    setLink(row) {
      // if (this.currentLinkIndex !== -1) {
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].goodsInfo = row;
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // } else {
      //   this.currentProp.goodsInfo = row;
      //   this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // }
      this.dialogVisible = false;
      this.isRadio = false;
    },
    batchNumGroup(val) {
      this.rule.seckillGoodsRuleList.forEach(v => {
        v.roundSeqNumGroupArray = val;
      });
    },
    handleClose(done) {
      this.batchRoundSeqNumGroupArray = [];
      done();
    },
    batchSetting() {
      this.dialogVisibleBatch = true;
    },
    inputChange() {
      this.dialogVisible = true;
      this.sole = true;
    },
    addGoods() {
      this.dialogVisible = true;
      // this.sole = true;
    },
    minimum() {
      this.isCollapse = !this.isCollapse;
    },
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        handle: ".my-handle",
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.rule.seckillGoodsRuleList.splice(oldIndex, 1)[0];
          _this.rule.seckillGoodsRuleList.splice(newIndex, 0, currRow);
        }
      });
    },
    toFirst(index) {
      if (index != 0) {
        this.rule.seckillGoodsRuleList.unshift(
          this.rule.seckillGoodsRuleList.splice(index, 1)[0]
        );
      }
    },
    upGo(index) {
      if (index != 0) {
        this.rule.seckillGoodsRuleList[
          index
        ] = this.rule.seckillGoodsRuleList.splice(
          index - 1,
          1,
          this.rule.seckillGoodsRuleList[index]
        )[0];
      } else {
        this.rule.seckillGoodsRuleList.push(
          this.rule.seckillGoodsRuleList.shift()
        );
      }
    },
    downGo(index) {
      if (index != this.rule.seckillGoodsRuleList.length - 1) {
        this.rule.seckillGoodsRuleList[
          index
        ] = this.rule.seckillGoodsRuleList.splice(
          index + 1,
          1,
          this.rule.seckillGoodsRuleList[index]
        )[0];
      } else {
        this.rule.seckillGoodsRuleList.unshift(
          this.rule.seckillGoodsRuleList.splice(index, 1)[0]
        );
      }
    },
    toBottom(index) {
      let temp;
      if (index >= this.rule.seckillGoodsRuleList.length - 1 || index < 0) {
        return this.rule.seckillGoodsRuleList;
      }
      temp = this.rule.seckillGoodsRuleList[index];
      this.rule.seckillGoodsRuleList.push(temp);
      this.rule.seckillGoodsRuleList.splice(index, 1);
      return this.rule.seckillGoodsRuleList;
    },
  }
};
</script>
<style lang="scss">
.game-select {
  .el-select {
    width: 140px !important;
    .el-input {
      width: 120px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.fixed-but {
  position: fixed;
  top: 150px;
  right: 20px;
}

.pvw {
  .pvws {
    border: 1px solid #d9d9d9;
    width: 350px;
    margin-right: 100px;
    position: relative;
    position: fixed;
    right: 0;
    background-color: #fff;
    // top: 200px;
    .depict {
      margin: 10px;
      line-height: 12px;
    }
    .commodityImg {
      width: 150px;
      height: 100px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .actcontent {
      width: 60%;
      height: 100px;
      margin-left: 20px;
      .activityTitle {
        font-size: 20px;
        font-weight: 700;
        margin-top: -2px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2; //显示的行
      }
      .activityPrice {
        font-size: 24px;
        color: #ff563a;
        font-weight: 600;
      }
      .originalCost {
        text-decoration: line-through;
        color: #c0c0c0;
      }
    }

    .hr {
      height: 10px;
      background-color: #f7f7f7;
    }
    .pvwimg {
      width: 100%;
      height: 100%;
      // position: relative;
    }
    .describe {
      width: 100%;
      color: #ff5336;
      font-size: 17px;
      font-weight: 500;
      position: absolute;
      left: 50%;
      margin-left: -50%;
      top: 215px;
    }
  }
  #audio_btn {
    position: absolute;
    left: 10px;
    top: 70px;
    z-index: 999999;
    width: 45px;
    height: 45px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
    background-size: contain;
    background-repeat: no-repeat;
  }
  // .rotate {
  //   -webkit-animation: rotating 1.2s linear infinite;
  //   -moz-animation: rotating 1.2s linear infinite;
  //   -o-animation: rotating 1.2s linear infinite;
  //   animation: rotating 1.2s linear infinite;
  // }
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
.priview {
  position: relative;
  width: 400px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .slot {
    .header-img-wrapper {
      box-sizing: border-box;
      .header-img {
        width: 100%;
        display: block;
      }
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }

    strong {
      font-size: 16px;
    }

    .preview-goods-list {
      padding: 15px;
      font-size: 12px;
      &:hover {
        .add-goods {
          display: block;
          position: absolute;
          cursor: pointer;
          display: none;
          top: 0;
          left: 0;
          z-index: 9030;
          zoom: 1;
          width: 34px;
          height: 34px;
          font-size: 12px;
          background-color: rgba(0, 0, 0, 0.8);
          border: 1px solid #fff;
          border-radius: 4px;
          text-align: center;
          line-height: 34px;
        }
      }
      .add-goods {
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }
      .goods-item {
        position: relative;
        background: #fff;
        margin-bottom: 10px;
        padding: 10px;
        border-radius: 5px;
        &:hover {
          .delete-item {
            display: block;
          }
        }
        .img-wrapper {
          width: 110px;
          height: 100px;
          margin-right: 10px;
          img {
            width: 100%;
            border-radius: 4px;
          }
        }

        .goods-name {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .tag {
          font-size: 12px;
          padding: 0 5px;
          color: #fff;
          border-radius: 30px;
        }
        .origin-price {
          color: #999;
          margin-top: 8px;
          text-decoration: line-through;
        }
      }
    }
  }
  .progress-wrapper {
    margin-bottom: 5px;

    .progress {
      position: relative;
      width: 134px;
      border-radius: 30px;
      overflow: hidden;
      height: 13px;
      line-height: 13px;
      .slide {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        height: 100%;
        border-radius: 30px;
      }
    }
    .percent {
      font-size: 12px;
      margin-left: 10px;
    }
  }
}
</style>
